var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperclip2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.45,
    height: 18.355,
    viewBox: "0 0 19.45 18.355",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "paperclip-2",
    transform: "translate(-558.04 -190.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.29,18.355a4.245,4.245,0,0,1-3.01-7.25l2.48-2.47A.75.75,0,0,1,10.82,9.7l-2.48,2.47a2.751,2.751,0,0,0,3.89,3.89l3.89-3.89a6.251,6.251,0,1,0-8.84-8.84L3.04,7.565a5.239,5.239,0,0,0,0,7.42.75.75,0,1,1-1.06,1.06,6.736,6.736,0,0,1,0-9.54l4.24-4.24a7.75,7.75,0,1,1,10.96,10.96l-3.89,3.89A4.216,4.216,0,0,1,10.29,18.355Z",
    transform: "translate(558.04 190.985)",
    fill: "#061133"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip2);
export default __webpack_public_path__ + "static/media/paperclip-2.9b16f74c4e1ee61872d41dc5bc66bc25.svg";
export { ForwardRef as ReactComponent };